export const heroSlides = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/de296e9d59e1469590f5774831dff4f2/4064a2796bd8258bf3bc0acb5f437b49.jpeg',
    title: '구조적 안정성과 현장 검증으로 완성하는 하천정비 기술',
    subtitle: '매트리스개비온 전문 제조기업 우진에코텍주식회사는 하천정비 및 침식방지 구조물 분야에서 안정적인 솔루션을 제공합니다.'
  },
  {
    id: 2,
    image: 'https://public.readdy.ai/ai/img_res/2ae92dd89988461c6ce42accd02d0080.jpg',
    title: '현장 검증된 품질과 기술력',
    subtitle: '20년 이상의 하천정비 현장 경험을 바탕으로 최적의 솔루션을 제공합니다.'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20a%20beautifully%20restored%20river%20with%20gabion%20mattress%20erosion%20control%20system%2C%20peaceful%20flowing%20water%2C%20lush%20green%20riverbanks%2C%20mountains%20in%20background%2C%20environmental%20harmony%2C%20sustainable%20engineering%2C%20natural%20landscape%2C%20professional%20photography%2C%20serene%20atmosphere&width=1920&height=1080&seq=hero3&orientation=landscape',
    title: '자연과 조화를 이루는 하천보호 솔루션',
    subtitle: '친환경적이면서도 구조적으로 안정적인 매트리스개비온 시스템을 제공합니다.'
  }
];
